<template>
  <div
    v-if="rewardAvailable || advanceAvailable"
    class="rounded-xl p-4 flex items-center gap-4 border border-secondary bg-gradient-to-r from-white to-[#eafff6]"
  >
    <div class="w-11 h-11 rounded-full bg-secondary flex items-center justify-center shrink-0">
      <Icon name="mdi-gift" :size="24" color="#419e83" />
    </div>
    <div class="flex-1 min-w-0">
      <div class="font-semibold text-sm text-gray-dark">
        {{ rewardAvailable ? '🎉 Récompense atteinte' : 'Récompense imminente' }}
      </div>
      <div class="text-xs text-slate-500">
        {{ message }}
      </div>
    </div>
    <div class="shrink-0">
      <!-- Products are offered from the header button, put forward while
           this banner shows: the banner only tells why. -->
      <Discount
        v-if="isPoint"
        :membership="membership"
        :auto-open="openReward"
        @attributed="$emit('refresh')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, toRef} from "vue";
import {LoyaltyCardMembership} from "@/loyalty-card/interfaces/hds/LoyaltyCard";
import Icon from "@/core/components/icon/Icon.vue";
import Discount from "@/customer/components/customer-loyalty-membership/CustomerLoyaltyMembershipDiscount.vue";
import useMembershipProgress from "@/loyalty-card-membership/composables/useMembershipProgress";

const props = defineProps<{
    membership: LoyaltyCardMembership;
    customerId: number;
    /** Open the attribution dialog as soon as the banner shows (counter shortcut). */
    openReward?: boolean;
}>();

defineEmits<{(e: "refresh"): void}>();

const {
    isProduct,
    isPoint,
    rewardsReady,
    rewardAvailable,
    nearThreshold,
    productRemaining
} = useMembershipProgress(toRef(props, "membership"));

/** A few stamps short: the product is worth offering with the basket of the day. */
const advanceAvailable = computed(() => nearThreshold.value);

const message = computed(() => {
    if (advanceAvailable.value) {
        const plural = productRemaining.value > 1 ? "s" : "";

        return `Plus que ${productRemaining.value} produit${plural} avant la récompense — `
            + "vous pouvez déjà l'offrir avec l'achat en cours.";
    }

    if (isProduct.value && rewardsReady.value >= 1) {
        const plural = rewardsReady.value > 1 ? "s" : "";

        return `${rewardsReady.value} produit${plural} offert${plural} à valider au comptoir.`;
    }

    return "Palier atteint — réduction disponible à valider au comptoir.";
});
</script>
